<template>
  <div class="form">
    <slot></slot>
    <div v-if="type == 'login' && active == 1 && screenWidth>=750">
      <p :class="{info_err: true}" v-show="error" :style="errorLeft">{{ error }}</p>
    </div>
    <div v-if="type == 'login' && active == 2">
      <p :class="{info_err: true, btm0: screenWidth>=750}" v-show="error" :style="errorLeft">{{ error }}</p>
    </div>
    <div v-if="type == 'login' && active == 1 && screenWidth<750">
      <p :class="{info_err: true, btm20: true}" v-show="error" :style="errorLeft">{{ error }}</p>
    </div>
    <div v-if="type == 'login' && active == 2 && screenWidth<750">
      <p :class="{info_err: true}" v-show="error" :style="errorLeft">{{ error }}</p>
    </div>
    <div v-if="type == 'forget' && active == 1 && screenWidth<750">
      <p :class="{info_err: true, btm25: true}" v-show="error" :style="errorLeft">{{ error }}</p>
    </div>
    <div v-if="type == 'forget' && active == 2 && screenWidth<750">
      <p :class="{info_err: true}" v-show="error" :style="errorLeft">{{ error }}</p>
    </div>
    <div v-if="type == 'forget' && active == 1 && screenWidth>=750">
      <p :class="{info_err: true, btm20: true}" v-show="error" :style="errorLeft">{{ error }}</p>
    </div>
    <div v-if="type == 'forget' && active == 2 && screenWidth>=750">
      <p :class="{info_err: true, btm50: true}" v-show="error" :style="errorLeft">{{ error }}</p>
    </div>
    <div v-if="type == 'reset'">
      <p :class="{info_err: true, btm26: true}" v-show="error" :style="errorLeft">{{ error }}</p>
    </div>
    <!-- <div>
      <p :class="{info_err: true, btm50: screenWidth>=750 && active !== 1}" v-show="error" :style="errorLeft">{{ error }}</p>
    </div>
    <div>
      <p :class="{info_err: true, btm50: screenWidth>=750 && active !== 1}" v-show="error" :style="errorLeft">{{ error }}</p>
    </div>
    <div>
      <p :class="{info_err: true, btm50: screenWidth>=750 && active !== 1}" v-show="error" :style="errorLeft">{{ error }}</p>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    error: {
      default: ''
    },
    errorLeft: {
      default: ''
    },
    active: {
      default: null
    },
    type: {
      default: 'login'
    }
  },
  data() {
    return {
      screenWidth: false
    };
  },
  mounted() {
    console.log(this.active, this.type);
    this.screenWidth = document.body.clientWidth

    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
@import url('../../assets/base.css');
.form {
  position: relative;
  .info_err {
    position: absolute;
    // bottom: -25px;
    // bottom: -50px;
  }
}
.btm50 {
  bottom: -50%;
}
.btm0 {
  bottom: 0!important;
}
.btm20 {
  bottom: -20%;
}
.btm25 {
  bottom: -25%;
}
</style>
